import { Image, ImageBackground, StyleSheet, View } from 'react-native';
import { calcSizeForDevice, getResponsiveSize } from 'utils/index';
import { Platform } from 'utils/platform';

import { ProfileBackground } from './ProfileBackground';

import BandLogo from 'assets/LogoHeader.png';
import BackgroundImageDesktop from 'assets/blueGradientBG.png';

import { WebDiv } from 'components/WebDiv';

export const ProfileLayout = ({ children }: { children: React.ReactNode }) => {
  const BackgroundWrapper = Platform.isTV ? ImageBackground : ProfileBackground;
  const backgroundProps = Platform.isTV
    ? { source: BackgroundImageDesktop, style: styles.background }
    : {};

  return (
    <WebDiv style={{ width: '100%', height: '100%' }}>
      <BackgroundWrapper {...backgroundProps}>
        <View style={Platform.isTV ? styles.tvContent : styles.webContent}>
          <Image
            source={BandLogo}
            style={[styles.logo, Platform.isTV ? styles.tvLogo : styles.webLogo]}
          />
          {children}
        </View>
      </BackgroundWrapper>
    </WebDiv>
  );
};

const styles = StyleSheet.create({
  background: {
    width: '100%',
    height: '100%',
    backgroundColor: '#070d31',
  },
  tvContent: {
    marginTop: calcSizeForDevice(132),
  },
  webContent: {
    marginTop: Number(getResponsiveSize({ base: 44, md: 61 })),
  },
  logo: {
    width: 'auto',
    resizeMode: 'contain',
  },
  tvLogo: {
    height: calcSizeForDevice(63),
  },
  webLogo: {
    height: Number(getResponsiveSize({ base: 44, md: 50 })),
  },
});

export default ProfileLayout;
